/* ==========================================================================
   ACORDEÓN FAQ (Delegación Global para Shopify)
   ========================================================================== */
document.addEventListener('click', function (event) {
  const head = event.target.closest('.faq .head');
  if (!head) return;

  const faq = head.closest('.faq');
  if (!faq) return;

  const container = faq.closest('.product-faqs');
  const content = faq.querySelector('.content');
  if (!content) return;

  const isOpen = faq.classList.contains('is-open');

  if (container) {
    container.querySelectorAll('.faq').forEach(function (otherFaq) {
      if (otherFaq !== faq) {
        otherFaq.classList.remove('is-open');
        const otherContent = otherFaq.querySelector('.content');
        if (otherContent) otherContent.style.height = '0px';
      }
    });
  }

  if (isOpen) {
    faq.classList.remove('is-open');
    content.style.height = '0px';
  } else {
    faq.classList.add('is-open');
    content.style.height = content.scrollHeight + 'px';
  }
});


/* ==========================================================================
   COMO REGALO
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
    const giftCheckbox = document.getElementById('ProductIsGift');
    const messageWrapper = document.getElementById('ProductGiftMessageWrapper');
    const messageInput = document.getElementById('ProductGiftMessage');

    if (!giftCheckbox || !messageWrapper) return;

    const toggleGiftMessage = () => {
        const isChecked = giftCheckbox.checked;
        messageWrapper.hidden = !isChecked;
        giftCheckbox.setAttribute('aria-expanded', isChecked);

        if (!isChecked && messageInput) {
            messageInput.value = '';
        }
    };

    toggleGiftMessage();
    giftCheckbox.addEventListener('change', toggleGiftMessage);
});


/* ==========================================================================
   ANIMACIONES GSAP & SCROLLTRIGGER
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const wine = document.getElementById('floatingWine');
  const jamon = document.getElementById('floatingJamon');

  /* --------------------------------------------------------------------------
     1. POSICIONES ESCRITORIO (3 ESTADOS)
     -------------------------------------------------------------------------- */
  const POSICIONES = {
    vino: {
      aparicion: { top: '0', left: '57%', opacity: 0, scale: 0.8 },
      reposoHero: { top: '8%', left: '57%', opacity: 1, scale: 1.1, rotation: 0 },
      finalScroll: { top: '60%', left: '75%', opacity: 1, scale: 1.45, rotation: 12 }
    },
    jamon: {
      aparicion: { top: '75%', right: '28%', opacity: 0, scale: 2 },
      reposoHero: { top: '35%', right: '30%', opacity: 1, scale: 1, rotation: 0 },
      finalScroll: { top: '79%', right: '25%', opacity: 1, scale: 1.1, rotation: -2 }
    }
  };

  /* --------------------------------------------------------------------------
     2. POSICIONES MÓVIL (3 ESTADOS) - AJUSTA AQUÍ TUS VALORES SI LO NECESITAS
     -------------------------------------------------------------------------- */
  const POSICIONES_MOVIL = {
    vino: {
      aparicion: { top: '15%', left: '90%', xPercent: -50, opacity: 0.8, scale: 0.75 },
      reposoHero: { top: '15%', left: '80%', xPercent: -50, opacity: 1, scale: 0.85, rotation: 0 },
      finalScroll: { top: '64%', left: '60%', xPercent: -50, opacity: 1, scale: 0.75, rotation: 8 }
    },
    jamon: {
      aparicion: { top: '60%', right: '10%', opacity: 0, scale: 1.5 },
      reposoHero: { top: '38%', right: '10%', opacity: 1, scale: 1, rotation: 0 },
      finalScroll: { top: '80%', right: '5%', opacity: 1, scale: 0.9, rotation: -2 }
    }
  };

  // Hover Vídeos en Tarjetas
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const video = card.querySelector('.card-hover-video');
    if (!video) return;
    card.addEventListener('mouseenter', () => { video.play().catch(() => {}); });
    card.addEventListener('mouseleave', () => { video.pause(); });
  });

  // Animaciones controladas por pantalla mediante matchMedia
  if (wine && jamon) {
    let mm = gsap.matchMedia();

    // ==========================================
    // A) ESCRITORIO (> 992px)
    // ==========================================
    mm.add("(min-width: 993px)", () => {
      const introTl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      introTl.fromTo('.hero-subtitle, .hero-title, .hero-cta', 
        { opacity: 0, y: 40 }, 
        { opacity: 1, y: 0, stagger: 0.15, duration: 1.5 }, 
        0
      );

      introTl.fromTo(wine, POSICIONES.vino.aparicion, { ...POSICIONES.vino.reposoHero, duration: 1.5 }, 0);
      introTl.fromTo(jamon, POSICIONES.jamon.aparicion, { ...POSICIONES.jamon.reposoHero, duration: 2.5 }, 0);

      const scrollTl = gsap.timeline({
        scrollTrigger: {
          trigger: '.home-intro-wrapper',
          start: 'top+=150 top', // Retrasa el inicio del scroll para evitar conflictos con la intro
          end: 'bottom bottom',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      scrollTl
        .fromTo(wine, POSICIONES.vino.reposoHero, { ...POSICIONES.vino.finalScroll, ease: 'none', immediateRender: false }, 0)
        .fromTo(jamon, POSICIONES.jamon.reposoHero, { ...POSICIONES.jamon.finalScroll, ease: 'none', immediateRender: false }, 0);
    });

    // ==========================================
    // B) MÓVIL (<= 992px)
    // ==========================================
    mm.add("(max-width: 992px)", () => {
      const introTlMobile = gsap.timeline({ defaults: { ease: 'power3.out' } });

      introTlMobile.fromTo('.hero-subtitle, .hero-title, .hero-cta', 
        { opacity: 0, y: 40 }, 
        { opacity: 1, y: 0, stagger: 0.15, duration: 1.5 }, 
        0
      );

      introTlMobile.fromTo(wine, POSICIONES_MOVIL.vino.aparicion, { ...POSICIONES_MOVIL.vino.reposoHero, duration: 1.5 }, 0);
      introTlMobile.fromTo(jamon, POSICIONES_MOVIL.jamon.aparicion, { ...POSICIONES_MOVIL.jamon.reposoHero, duration: 2.5 }, 0);

      const scrollTlMobile = gsap.timeline({
        scrollTrigger: {
          trigger: '.home-intro-wrapper',
          start: 'top+=150 top', // Retrasa el inicio del scroll para evitar conflictos con la intro
          end: 'bottom bottom',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      scrollTlMobile
        .fromTo(wine, POSICIONES_MOVIL.vino.reposoHero, { ...POSICIONES_MOVIL.vino.finalScroll, ease: 'none', immediateRender: false }, 0)
        .fromTo(jamon, POSICIONES_MOVIL.jamon.reposoHero, { ...POSICIONES_MOVIL.jamon.finalScroll, ease: 'none', immediateRender: false }, 0);
    });
  }


  /* ---------------------------------------------
     2. REVEAL GLOBAL (APLICA A .gsap-reveal)
     --------------------------------------------- */
  const reveals = gsap.utils.toArray('.gsap-reveal');
  reveals.forEach((el) => {
    gsap.fromTo(
      el,
      { y: 40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );
  });


  /* ---------------------------------------------
     3. NOSOTROS - TARJETAS INTERACTIVAS
     --------------------------------------------- */
  const nosotrosCards = gsap.utils.toArray('.nosotros-card-hover');
  nosotrosCards.forEach((card) => {
    const overlay = card.querySelector('.nosotros-card-hover__overlay');
    const img = card.querySelector('.nosotros-card-hover__media img');
    const tl = gsap.timeline({ paused: true });

    if (overlay) tl.to(overlay, { opacity: 1, duration: 0.4, ease: "power2.out" }, 0);
    if (img) tl.to(img, { scale: 1.08, duration: 0.5, ease: "power2.out" }, 0);

    card.addEventListener('mouseenter', () => tl.play());
    card.addEventListener('mouseleave', () => tl.reverse());
  });


  /* ---------------------------------------------
     4. DEHESA / JAMONES - TARJETAS PRODUCTO
     --------------------------------------------- */
  const productJamonesCards = gsap.utils.toArray('.gsap-card');
  productJamonesCards.forEach((card) => {
    const img = card.querySelector('.jamones-card__media img');
    const tl = gsap.timeline({ paused: true });

    tl.to(card, { y: -6, duration: 0.3, ease: "power2.out" }, 0);
    if (img) tl.to(img, { scale: 1.06, duration: 0.4, ease: "power2.out" }, 0);

    card.addEventListener('mouseenter', () => tl.play());
    card.addEventListener('mouseleave', () => tl.reverse());
  });


  /* ---------------------------------------------
     5. SECCIÓN 4 ORIGEN - FOTOS ACUMULATIVAS EN SCROLL
     --------------------------------------------- */
  const originSection = document.querySelector('.jamones-origin');
  const photos = gsap.utils.toArray('.jamones-origin__photo');

  if (originSection && photos.length > 0) {
    const originTl = gsap.timeline({
      scrollTrigger: {
        trigger: originSection,
        start: "top top",
        end: "+=200%",
        pin: true,
        scrub: 0.6
      }
    });

    photos.forEach((photo) => {
      originTl.to(photo, {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: "power2.out"
      }, "+=0.3");
    });
  }

});